<template>
  <maintenance-alert :user-name="user.name" disabled-module="billing" />
</template>

<script>
  import MaintenanceAlert from '@/components/modals/MaintenanceAlert.vue';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      MaintenanceAlert,
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      ...mapGetters('auth', ['user']),
    },
    methods: {
      ...mapActions('modalStepsAfterLogin', [
        'findStepByKey',
        'updateStepStatus',
      ]),

      async handleShowBillingModal() {
        this.loading = true;
        try {
          const updateStep = await this.findStepByKey('billingModuleStatus');
          if (updateStep) {
            updateStep.doneRequired = false;
            this.updateStepStatus(updateStep);
          }
        } catch (error) {
          // TODO: resolve error
        }
        this.loading = false;
      },
    },
  };
</script>
